import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <h3>Simak</h3>
            <address>
              <div className="address-line">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="address-icon" />
                <span>SIMAK IT Private Limited, 3rd Floor, Datta Palace, Gandhi Chowk Amravati, Maharashtra, India.</span>
              </div>
                <div className="address-line">
                <FontAwesomeIcon icon={faPhone} className="address-icon" />
                <a href="tel:9422840076" className="phone-link">9422840076</a>
               </div>

              <div className="address-line">
                <FontAwesomeIcon icon={faEnvelope} className="address-icon" />
                <a href="mailto:simakitpl@gmail.com" className="email-link">simakitpl@gmail.com</a>
              </div>
            </address>
            <div className="social-logo">
              <a href="https://www.linkedin.com/company/simak-it-private-limited" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="mailto:simakitpl@gmail.com" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faEnvelope} className="social-icon" />
              </a>
            </div>
          </div>
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-services">
            <h3>Our Services</h3>
            <ul>
              <li><Link to="/services">DMS Services</Link></li>
              <li><Link to="/services">IT Solutions</Link></li>
              <li><Link to="/services">Document Management</Link></li>
              <li><Link to="/services">Consulting</Link></li>
              <li><Link to="/services">Support</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy;2025 Simak IT Pvt. Ltd. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;